<template>
  <div class="filter-group"
       :class="isGroupOpen ? '_open' : null"
  >
    <div v-if="toggle" class="filter-group__header" @click.prevent="onGroupToggle">
      <div class="filter-group__title" v-if="title">{{title}}
        <template v-if="note">&nbsp;<b>({{note}})</b></template>
      </div>
      <div class="filter-group__btn"></div>

    </div>
    <div v-else class="filter-group__header _disabled">
      <div class="filter-group__title" v-if="title">{{title}}
        <template v-if="note">&nbsp;<b>({{note}})</b></template>
      </div>
    </div>
    <v-slide-toggle :active="isGroupOpen"
                    class="filter-group__content-wrap">
      <div class="filter-group__content">
        <slot></slot>
      </div>
    </v-slide-toggle>
  </div>
</template>

<script>
  export default {
    name: 'FilterGroup',
    props: {
      title: {
        type: String
      },
      note: {
        type: String
      },
      openDefault: {
        type: Boolean,
        default: false
      },
      toggle: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        isOpen: false
      }
    },
    computed: {
      isGroupOpen() {
        return this.openDefault ? !this.isOpen : this.isOpen
      }
    },
    methods: {
      onGroupToggle() {
        this.isOpen = !this.isOpen
      }
    }
  }
</script>

<style lang="less">

</style>
